<template>
  <v-container align="start">
    <transition name="fade-transition" group>

      <div v-if="customer == null && ready">
        <v-row align="start" justify="start">
            <h2>{{ $t('views.checkout.billing.billing') }}</h2>
        </v-row>

        <v-row align="start" justify="start">
          <address-form :locale="locale" storageKey="billingAddress"></address-form>
        </v-row>
        <div v-if="$store.state.checkout.billingAddress.address">
          <v-row align="start" justify="start" v-if="$store.state.checkout.billingAddress.address.isShippingAddress === false">
            <v-row align="start" justify="start">
                <v-col>
                  <h5>{{ $t('views.checkout.billing.shipping') }}</h5>
                </v-col>
            </v-row>
            <address-form :locale="locale" storageKey="shippingAddress"></address-form>
          </v-row>
        </div>

      </div>
    </transition>
  </v-container>
</template>

<script>
// @ is an alias to /src
import CartService from "@/services/CartService.js"
import CustomerService from "@/services/CustomerService.js"
import AddressForm from '@/packages/Address/src/resources/components/IndexForm'

export default {
  name: 'billing',
  components: {
    AddressForm
  },
  data: () => ({
    ready: false,
    addAddressDialog: false,
    locale: 'en',
    addressSelected: false,
    customer: null,
    name: '',
    email: '',
    address: '',
    select: null,
  }),
  mounted() {
    this.getCart();
    this.getCustomer();
    this.locale = this.$store.state.app.locale.code;
  },
  computed: {
    //
  },
  methods: {
    getCart(url_key) {
      if (this.$store.state.checkout.cart === null) {
        CartService.getCart()
          .then(cart => {
            this.cart = cart
         }).catch(error => {
           console.log(error);
         })
      } else {
        this.cart = this.$store.state.checkout.cart;
      }
    },
    getCustomer() {
      CustomerService.getLoggedInCustomerAddresses()
        .then(cart => {
          this.customer = this.$store.state.customer;
          this.ready = true;
       }).catch(error => {
         console.log(error);
       })
    },
    saveShippingMethodToCart(shippingMethod) {
      CartService.saveShippingMethodToCart(shippingMethod)
    },
  }
};
</script>

<style>
  .fade-me-enter-active, .fade-me-leave-active {
    transition: opacity 1.5s;
  }
  .fade-me-enter, .fade-me-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  }
</style>
